/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_App_AppsInputs */

const en_nav_app_apps = /** @type {(inputs: Nav_App_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apps`)
};

const es_nav_app_apps = /** @type {(inputs: Nav_App_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicaciones`)
};

/**
* | output |
* | --- |
* | "Apps" |
*
* @param {Nav_App_AppsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_app_apps = /** @type {((inputs?: Nav_App_AppsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_App_AppsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_app_apps(inputs)
	return en_nav_app_apps(inputs)
});